import {flickityLib} from '../lazy_modules';
import {OurFeedbackSvc} from '../services/OurFeedbackSvc';
import {TranslateSvc} from '../services/TranslateSvc';

abstract class FeedbackSwipable implements ng.IComponentController {
    readonly flicktyPromise: ng.IPromise<any>;
    readonly abstract feedbacks: IFeedBack[];

    /* @ngInject */
    constructor(protected $element: ng.IAugmentedJQuery,
                protected $q: ng.IQService,
                protected TranslateSvc: TranslateSvc,
                protected OurFeedbackSvc: OurFeedbackSvc) {
        this.flicktyPromise = options.handHeld ?
            $q(resolve => loadScripts([flickityLib], resolve)) :
            $q.reject(null);
    }

    $postLink() {
        this.flicktyPromise.then(() => {
            const Flickity = (window as any).Flickity;
            new Flickity(this.$element[0].firstChild, {
                cellSelector: '.feedback',
                prevNextButtons: false,
                wrapAround: true,
                resize: false,
                cellAlign: 'left',
                adaptiveHeight: true,
                setGallerySize: false
            });
        });
    }
}

class FeedbackSwipableByKind extends FeedbackSwipable {
    readonly kind: string;
    readonly feedbacks = _.range(1, 4).map(i => _.mapObject<IFeedBack>({
        twit: `landing.${this.kind}.feedback${i}`,
        name: `landing.${this.kind}.feedback${i}.author`,
        company: `landing.${this.kind}.feedback${i}.author.position`
    }, v => this.TranslateSvc.get(v)) as IFeedBack);
}

class FeedbackSwipableByPage extends FeedbackSwipable {
    count: number;
    private static readonly MaxTwitSize = 230;

    feedbacks: IFeedBackDefinition[];

    constructor(protected $element: ng.IAugmentedJQuery,
                protected $q: ng.IQService,
                protected TranslateSvc: TranslateSvc,
                protected OurFeedbackSvc: OurFeedbackSvc) {
        super($element, $q, TranslateSvc, OurFeedbackSvc);
    }

    $onInit() {
        const allFeedbacks = this.OurFeedbackSvc
            .getForPage()
            .filter(f => f.twit.length < FeedbackSwipableByPage.MaxTwitSize);

        this.feedbacks = this.count ? _.first(allFeedbacks, this.count) : allFeedbacks;
    }
}

angular.module('animatronApp.feedback').component('feedbackSwipableByKind', {
    bindings: {
        kind: '@'
    },
    controller: FeedbackSwipableByKind,
    templateUrl: require('landing/feedback-swipable.html')
});

angular.module('animatronApp.feedback').component('feedbackSwipableByPage', {
    bindings: {
        count: '<'
    },
    controller: FeedbackSwipableByPage,
    templateUrl: require('landing/feedback-swipable.html')
});




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/FeedbackSwipable.ts